import { render, staticRenderFns } from "./Nomenclature-page.vue?vue&type=template&id=6dd72582&scoped=true&"
import script from "./Nomenclature-page.vue?vue&type=script&lang=js&"
export * from "./Nomenclature-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd72582",
  null
  
)

export default component.exports